import { CapacitorAccess } from "../capacitor";
import { DeviceAccessor, LogManager, OrientationAccessorDef } from "@mcleod/core";
import { AppRouter } from "../router/AppRouter";

const log = LogManager.getLogger("mobile-common.DeviceOrientationAccessor");

export class MobileDeviceOrientationAccessor implements OrientationAccessorDef {
    private static _instance: MobileDeviceOrientationAccessor;

    private constructor() {
        if (DeviceAccessor.isTablet) {
            MobileDeviceOrientationAccessor.addOrientationChangeListener(() => {
                AppRouter.instance?.redisplayCurrentRoute();
            });
        } else {
            this.lock({ orientation: "portrait-primary" });
        }
    }

    public static get instance(): MobileDeviceOrientationAccessor {
        this._instance ??= new MobileDeviceOrientationAccessor();
        return this._instance;
    }

    private get plugin(): OrientationAccessorDef | null {
        return CapacitorAccess.plugins?.ScreenOrientation;
    }

    async lock(options: { orientation: OrientationType }): Promise<void> {
        if (!this.plugin) {
            log.error("Attempted to lock device orientation - Orientation plugin not found.");
        }
        return this.plugin?.lock(options);
    }

    async orientation(): Promise<{ type: OrientationType }> {
        if (this.plugin) {
            return this.plugin.orientation();
        } else {
            return new Promise(() => { return window.screen.orientation.type });
        }
    }

    async unlock(): Promise<void> {
        if (!this.plugin) {
            log.error("Attempted to unlock device orientation - Orientation plugin not found.");
        }
        return this.plugin?.unlock();
    }

    get isLandscape(): boolean {
        return window.screen.orientation.type.toLowerCase().includes('landscape');
    }

    get isPortrait(): boolean {
        return window.screen.orientation.type.toLowerCase().includes('portrait');
    }

    static addOrientationChangeListener(func: (this: ScreenOrientation, ev: Event) => any) {
        screen.orientation.addEventListener('change', func);
    }

    static removeOrientationChangeListener(func: (this: ScreenOrientation, ev: Event) => any) {
        screen.orientation.removeEventListener('change', func);
    }
}
